export default __webpack_public_path__ + "static/media/Alger.599c4b33.ttf";